import React, { useState, useEffect, useContext, useMemo, useCallback } from 'react'
import { BufferService, LoadingContext, M_StateActions, NavigateContext, M_DrawerTableTextField, M_InputTextField, M_CheckBox, M_Select, M_SimpleTable, M_Button } from 'src/components/M_Components'
import { Stepper, Step, StepLabel, Tooltip, useMediaQuery } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useForm, Controller } from 'react-hook-form'

export default function CreateTrailer() {

    const [optionsTrailer, setOptionsTrailer] = useState([])
    const [optionsInsurance, setOptionsInsurance] = useState([])
    const [dataTrailer, setDataTrailer] = useState(new Map())
    const [dataDangerClassDriver, setDataDangerClassDriver] = useState([])
    const [dataInsurance, setDataInsurance] = useState([])
    const [dataCapacity, setDataCapacity] = useState([])
    const [dataLicenses, setDataLicenses] = useState([])
    const [capacityColumnGroups, setCapacityColumnGroups] = useState(1)
    const dispatch = useDispatch()
    const M_State = useSelector((state) => state.StateKeyValue)
    const [id, setId] = useState(M_State.filter(obj => obj.key === 'selectedTab')[0]?.value)
    const [trailerId, setTrailerId] = useState("")
    const [operation, setOperation] = useState("")
    const [isFirstLoop, setIsFirstLoop] = useState(true)
    const [activeStep, setActiveStep] = useState(0)
    // Estado para armazenar os nomes de exibição das chaves estrangeiras
    const [foreignKeyNames, setForeignKeyNames] = useState({})
    const bufferServiceTrailer = new BufferService('Trailer')
    const bufferServiceInsurances = new BufferService('Insurance')
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const { t } = useTranslation()
    const matches = useMediaQuery("(max-width: 570px)")
    const matchesAlternative = useMediaQuery("(max-width: 1030px)")
    const steps = ['CreateTrailer', 'Licenses']


    const columnsADR = [
        { Name: 'ADRClassification', NormalizedName: t("DangerClass"), Type: 'select', ForeignTableToPassId: 'ADRClassificationId', ForeignKeyName: 'Description', ForeignTableName: 'ADRClassification' },
        { Name: 'CertificateNumber', NormalizedName: t("CertificateNumber"), Type: 'string' },
        { Name: 'ExpirationDate', NormalizedName: t("ADRExpirationDate"), Type: 'date' }
    ]

    const columnsLicenses = [
        { Name: 'ResourceLicense', NormalizedName: t("ResourceLicense"), Type: 'select', ForeignTableToPassId: 'ResourceLicenseId', ForeignKeyName: 'Name', ForeignTableName: 'ResourceLicense' },
        { Name: 'LicenseNumber', NormalizedName: t("LicenseNumber"), Type: 'string' },
        { Name: 'IssuingAuthority', NormalizedName: t("IssuingAuthority"), Type: 'string' },
        { Name: 'ExpirationDate', NormalizedName: t("ExpirationDate"), Type: 'date' }
    ]

    const columnsCapacity = []

    for (let i = 1; i <= capacityColumnGroups; i++) {
        columnsCapacity.push(
            { Name: `Quantity${i}`, NormalizedName: `${t("Quantity")} ${i}`, Type: 'int32' },
            { Name: `Capacity${i}`, NormalizedName: `${t("Capacity")} ${i}`, Type: 'select', ForeignTableToPassId: 'CapacityId', ForeignKeyName: 'Length', ForeignTableName: 'ContainerCapacity', valueId: i },
        )
    }


    useEffect(() => {
        if (isFirstLoop) {
            ctx.setIsLoad(true)
            getSessionStorageData(id)
            setIsFirstLoop(false)
        }
        // eslint-disable-next-line 
    }, [])

    // eslint-disable-next-line 
    useEffect(() => {
        const newId = M_State.filter(obj => obj.key === 'selectedTab')[0]?.value
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const M_StateData = M_State.filter(obj => obj.key === sessionID)[0]?.value
        if (M_StateData) {
            const tempOT = M_StateData.filter(obj => obj.key === `optionsTrailer`)[0]?.value
            const tempOI = M_StateData.filter(obj => obj.key === `optionsInsurance`)[0]?.value
            const tempDT = M_StateData.filter(obj => obj.key === `dataTrailer`)[0]?.value
            const tempDD = M_StateData.filter(obj => obj.key === `dataDangerClassDriver`)[0]?.value
            const tempDI = M_StateData.filter(obj => obj.key === `dataInsurance`)[0]?.value
            const tempTI = M_StateData.filter(obj => obj.key === `trailerId`)[0]?.value
            const tempOP = M_StateData.filter(obj => obj.key === `operation`)[0]?.value
            const tempDC = M_StateData.filter(obj => obj.key === `dataCapacity`)[0]?.value
            const tempCCG = M_StateData.filter(obj => obj.key === `capacityColumnGroups`)[0]?.value
            if (tempOT || tempOI || tempDT || tempDD || tempDI || tempTI || tempOP || tempDC || tempCCG) {
                setOptionsTrailer(tempOT)
                setOptionsInsurance(tempOI)
                const loadedDataTrailer = new Map(tempDT)
                setDataTrailer(loadedDataTrailer)
                setDataDangerClassDriver(tempDD)
                setDataInsurance(tempDI)
                setTrailerId(tempTI)
                setOperation(tempOP)
                setDataCapacity(tempDC)
                setCapacityColumnGroups(tempCCG)

                if (tempOT && tempDT) {
                    const initialForeignKeyNames = {}
                    const fields = Object.fromEntries(loadedDataTrailer)

                    tempOT.filter(o => o.Type === 'drawerTable').forEach(elem => {
                        const displayValue = fields[elem.Name]
                        if (displayValue) {
                            initialForeignKeyNames[elem.Name] = displayValue
                        }
                    })
                    setForeignKeyNames(initialForeignKeyNames)
                }

                if (tempDT) {
                    reset(Object.fromEntries(tempDT))
                }

                ctx.setIsLoad(false)
                return
            }
        }
        getTrailer()
    }

    const { handleSubmit, control, reset, formState: { errors }, getValues } = useForm({
        defaultValues: Object.fromEntries(dataTrailer)
    })

    const saveStateToRedux = useCallback(() => {
        const formValues = getValues()
        const combinedDataForRedux = {
            ...formValues,
            ...foreignKeyNames
        }

        const combinedDataTrailerFinal = new Map(dataTrailer)
        Object.entries(combinedDataForRedux).forEach(([key, value]) => {
            combinedDataTrailerFinal.set(key, value)
        })

        const tempArray = [
            { key: 'optionsTrailer', value: optionsTrailer },
            { key: 'optionsInsurance', value: optionsInsurance },
            { key: 'dataTrailer', value: Array.from(combinedDataTrailerFinal) },
            { key: 'dataDangerClassDriver', value: dataDangerClassDriver },
            { key: 'dataInsurance', value: dataInsurance },
            { key: 'dataCapacity', value: dataCapacity },
            { key: 'trailerId', value: trailerId },
            { key: 'operation', value: operation },
            { key: 'capacityColumnGroups', value: capacityColumnGroups },
            { key: 'dataLicenses', value: dataLicenses }
        ]

        dispatch(M_StateActions.addM_State({ key: id, value: tempArray }))

    }, [
        id, optionsTrailer, optionsInsurance, dataTrailer,
        dataDangerClassDriver, dataInsurance, trailerId,
        operation, dataCapacity, capacityColumnGroups,
        dispatch,
        getValues,
        foreignKeyNames, dataLicenses
    ])

    useEffect(() => {
        return () => {
            saveStateToRedux()
        }
    }, [id, saveStateToRedux])

    const getTrailer = async () => {
        const getOperation = ctx.passValue.get('operation')
        const lines = ctx.passValue?.get('lines') || ""
        const getId = lines.Id
        ctx.passValue.delete('operation')
        ctx.passValue.delete('lines')
        ctx.setPassValue(new Map(ctx.passValue))
        setOperation(getOperation)
        setTrailerId(getId)

        let trailerOptions = optionsTrailer
        let insuranceOptions = optionsInsurance

        if (trailerOptions.length === 0) {
            const responseOptions = await bufferServiceTrailer.options()

            if (responseOptions.name === 'AxiosError') {
                ctx.toastMessages('error', responseOptions.response.data.Errors[0], '')
                return
            }

            trailerOptions = responseOptions.filter(option => !option.IsHiddenList)
            setOptionsTrailer(trailerOptions)
        }

        if (insuranceOptions.length === 0) {
            const response = await bufferServiceInsurances.options()
            if (response.name === 'AxiosError') {
                ctx.toastMessages('error', response.response.data.Errors[0], '')
                return
            }

            insuranceOptions = response.filter(option => !option.IsHiddenList && option.Name !== 'Trailer' && option.Name !== 'Transport')
            setOptionsInsurance(insuranceOptions)
        }

        if (getOperation === 'edit' || getOperation === 'view') {
            const valueDataTrailer = await bufferServiceTrailer.getId(getId)

            if (valueDataTrailer.name === 'AxiosError') {
                ctx.toastMessages('error', valueDataTrailer.response.data.Errors[0], '')
                ctx2.closeTab(id)
                return
            }

            setDataDangerClassDriver(valueDataTrailer.ADRCertificates)
            setDataInsurance(valueDataTrailer.Insurances)
            setDataLicenses(valueDataTrailer.ResourceLicenses || [])

            const normalizedCapacities = normalizeDataForEdit(valueDataTrailer.TrailerCapacities || [])
            setDataCapacity(normalizedCapacities)

            const defaultFormValues = {}
            const initialForeignKeyNames = {}
            const newDataTrailer = new Map(dataTrailer)

            trailerOptions.forEach(obj => {
                defaultFormValues[obj.Name] = valueDataTrailer[obj.Name]
                newDataTrailer.set(obj.Name, valueDataTrailer[obj.Name])
                if (obj.IsForeignKey) {
                    const idField = obj.ForeignTableToPassId
                    const labelField = obj.Name
                    defaultFormValues[idField] = valueDataTrailer[idField]
                    initialForeignKeyNames[labelField] = valueDataTrailer[labelField]
                }
            })

            setDataTrailer(newDataTrailer)
            setForeignKeyNames(initialForeignKeyNames)
            reset(defaultFormValues)
        }
        ctx.setIsLoad(false)
    }

    const createStructureADR = useCallback((value, field, index, table) => {
        if (table === 'ADR') {
            setDataDangerClassDriver(line => line.map(prev => {
                if (prev.Id == index) {
                    return { ...prev, [field]: value }
                } return prev
            }))
        } else if (table === 'Insurance') {
            setDataInsurance(line => line.map(prev => {
                if (prev.Id == index) {
                    return { ...prev, [field]: value }
                } return prev
            }))
        } else if (table === 'Licenses') {
            setDataLicenses(line => line.map(prev => {
                if (prev.Id == index) {
                    return { ...prev, [field]: value }
                } return prev
            }))
        } else if (table === 'Capacity') {
            setDataCapacity(line => line.map(prev => {
                if (prev.Id == index) {
                    return { ...prev, [field]: value }
                } return prev
            }))

            console.log("dataCapacity", dataCapacity)
        }
    }, [setDataDangerClassDriver, setDataInsurance, setDataCapacity])

    const normalizeDataForEdit = (trailerCapacitiesData) => {
        let maxDetails = 0

        const capacityLines = trailerCapacitiesData.map((item, lineIndex) => {
            const newLine = { Id: lineIndex }
            maxDetails = Math.max(maxDetails, item.Details.length)

            item.Details.forEach((detail, colIndex) => {
                const colNumber = colIndex + 1

                newLine[`Quantity${colNumber}`] = String(detail.Quantity)
                newLine[`Capacity${colNumber}`] = detail.Capacity
                newLine[`CapacityId${colNumber}`] = detail.CapacityId
            })

            return newLine
        })

        setCapacityColumnGroups(maxDetails)
        return capacityLines
    }

    const buildTrailerCapacities = () => {
        const trailerCapacitiesArray = []

        dataCapacity.forEach(row => {
            const detailsForThisRow = []

            for (let i = 1; i <= capacityColumnGroups; i++) {
                const qty = row[`Quantity${i}`]
                const capId = row[`CapacityId${i}`]

                if (
                    qty !== null && qty !== undefined && qty !== '' &&
                    capId !== null && capId !== undefined && capId !== ''
                ) {
                    detailsForThisRow.push({
                        Quantity: Number(qty),
                        CapacityId: Number(capId)
                    })
                }
            }

            if (detailsForThisRow.length > 0) {
                trailerCapacitiesArray.push({
                    TrailerId: dataTrailer.get('TrailerId'),
                    Details: detailsForThisRow
                })
            }
        })

        return trailerCapacitiesArray
    }

    const onError = (errors) => {
        const errorKeys = Object.keys(errors)

        if (errorKeys.length > 0) {
            const firstErrorKey = errorKeys[0]

            const failedField = optionsTrailer.find(elem =>
                elem.Name === firstErrorKey ||
                (elem.IsForeignKey && elem.ForeignTableToPassId === firstErrorKey)
            )

            let fieldName = t("RequiredFieldsErrorTitle")

            if (failedField) {
                fieldName = failedField.NormalizedName
            } else {
                fieldName = firstErrorKey
            }

            ctx.toastMessages('error', fieldName, t("RequiredField"))
        }
    }


    const onSubmit = (data) => {
        ctx.setIsLoad(true)
        const finalData = {
            ...data,
            Insurances: dataInsurance,
            ADRCertificates: dataDangerClassDriver,
            TrailerCapacities: buildTrailerCapacities(),
            ResourceLicenses: dataLicenses
        }

        console.log("finalData", finalData)
        if (operation === 'edit') {
            bufferServiceTrailer.update(trailerId, finalData).then((response) => {
                if (response.name === 'AxiosError') {
                    ctx.toastMessages("error", '', response.response.data.Errors[0])
                    ctx.setIsLoad(false)
                    return
                }
                ctx.toastMessages("success", '', t("SuccessUpdate"))
                ctx2.closeTab(id)
                ctx.setIsLoad(false)
            })
        } else {
            bufferServiceTrailer.post(finalData).then((response) => {
                if (response.name === 'AxiosError') {
                    ctx.toastMessages("error", '', response.response.data.Errors[0])
                    ctx.setIsLoad(false)
                    return
                }
                ctx.toastMessages("success", '', t("SuccessCreate"))
                ctx2.closeTab(id)
                ctx.setIsLoad(false)
            })
        }
    }

    const headerTableADR = useMemo(() => columnsADR.map((value, index) => {
        return {
            Id: index + 1,
            header: value.NormalizedName,
            field: value.Name,
            body: (line) => {
                if (value.Type === 'select') {
                    return (
                        <M_DrawerTableTextField
                            tableLabel={value.NormalizedName}
                            required={value.Required}
                            entity={value.ForeignTableName}
                            value={line[value.ForeignTableToPassId] && {
                                [value.ForeignTableToPassId]: line[value.ForeignTableToPassId],
                                [value.ForeignKeyName]: line[value.Name]
                            } || null}
                            filterField={value.ForeignKeyName}
                            labelFields={[value.ForeignKeyName]}
                            onSubmitValue={obj => {
                                if (obj) {
                                    createStructureADR(obj[value.ForeignKeyName] || '', value.Name, line.Id, 'ADR')
                                    createStructureADR(obj[value.ForeignTableToPassId] || '', value.ForeignTableToPassId, line.Id, 'ADR')
                                } else {
                                    createStructureADR('', value.Name, line.Id, 'ADR')
                                    createStructureADR('', value.ForeignTableToPassId, line.Id, 'ADR')
                                }
                            }}
                            disabled={operation === 'view' ? true : false}
                            valueField={value.ForeignTableToPassId}
                        />
                    )
                } else if (value.Type === 'string') {
                    return (
                        <M_InputTextField
                            type="text"
                            value={line[value.Name] || ''}
                            onChange={(e) => createStructureADR(e.target.value, value.Name, line.Id, 'ADR')}
                            disabled={operation === 'view' ? true : false}
                        />
                    )
                } else if (value.Type === 'date') {
                    return (
                        <M_InputTextField
                            type="date"
                            value={line[value.Name] || ''}
                            onChange={(e) => createStructureADR(e.target.value, value.Name, line.Id, 'ADR')}
                            disabled={operation === 'view' ? true : false}
                        />
                    )
                }
            }
        }
    }), [columnsADR, createStructureADR, t])

    const headerLicenses = useMemo(() => columnsLicenses.map((value, index) => {
        return {
            Id: index + 1,
            header: value.NormalizedName,
            field: value.Name,
            body: (line) => {
                if (value.Type === 'select') {
                    return (
                        <M_DrawerTableTextField
                            tableLabel={value.NormalizedName}
                            required={value.Required}
                            entity={value.ForeignTableName}
                            value={line[value.ForeignTableToPassId] && {
                                [value.ForeignTableToPassId]: line[value.ForeignTableToPassId],
                                [value.ForeignKeyName]: line[value.Name]
                            } || null}
                            filterField={value.ForeignKeyName}
                            labelFields={[value.ForeignKeyName]}
                            onSubmitValue={obj => {
                                if (obj) {
                                    createStructureADR(obj[value.ForeignKeyName] || '', value.Name, line.Id, 'Licenses')
                                    createStructureADR(obj[value.ForeignTableToPassId] || '', value.ForeignTableToPassId, line.Id, 'Licenses')
                                } else {
                                    createStructureADR('', value.Name, line.Id, 'Licenses')
                                    createStructureADR('', value.ForeignTableToPassId, 'Licenses')
                                }
                            }}
                            disabled={operation === 'view' ? true : false}
                            valueField={value.ForeignTableToPassId}
                            FILTER={'AllowedForTrailer eq true'}
                        />
                    )
                } else if (value.Type === 'date') {
                    return (
                        <M_InputTextField
                            type="date"
                            value={line[value.Name] || ''}
                            onChange={(e) => createStructureADR(e.target.value, value.Name, line.Id, 'Licenses')}
                            disabled={operation === 'view' ? true : false}
                        />
                    )
                } else if (value.Type === 'string') {
                    return (
                        <M_InputTextField
                            type="text"
                            value={line[value.Name] || ''}
                            onChange={(e) => createStructureADR(e.target.value, value.Name, line.Id, 'Licenses')}
                            disabled={operation === 'view' ? true : false}
                        />
                    )
                }
            }
        }
    }), [columnsLicenses, createStructureADR, t])

    const headerTableInsurances = useMemo(() => optionsInsurance.map((value, index) => {
        return {
            Id: index + 1,
            header: value.NormalizedName,
            field: value.Name,
            body: (line) => {
                if (value.Name === 'Type' || value.Name === 'Coverage') {
                    return (
                        <M_DrawerTableTextField
                            tableLabel={value.NormalizedName}
                            required={value.Required}
                            entity={value.ForeignTableName}
                            value={line[value.ForeignTableToPassId] && {
                                [value.ForeignTableToPassId]: line[value.ForeignTableToPassId],
                                [value.ForeignKeyName]: line[value.Name]
                            } || null}
                            filterField={value.ForeignKeyName}
                            labelFields={[value.ForeignKeyName]}
                            onSubmitValue={obj => {
                                if (obj) {
                                    createStructureADR(obj[value.ForeignKeyName] || '', value.Name, line.Id, 'Insurance')
                                    createStructureADR(obj[value.ForeignTableToPassId] || '', value.ForeignTableToPassId, line.Id, 'Insurance')
                                } else {
                                    createStructureADR('', value.Name, line.Id, 'Insurance')
                                    createStructureADR('', value.ForeignTableToPassId, line.Id, 'Insurance')
                                }
                            }}
                            disabled={operation === 'view' ? true : false}
                            valueField={value.ForeignTableToPassId}
                        />
                    )
                } else if (value.Type === 'string') {
                    return (
                        <M_InputTextField
                            type="text"
                            value={line[value.Name] || ''}
                            onChange={(e) => createStructureADR(e.target.value, value.Name, line.Id, 'Insurance')}
                            disabled={operation === 'view' ? true : false}
                        />
                    )
                } else if (value.Type === 'decimal') {
                    return (
                        <M_InputTextField
                            type="number"
                            value={line[value.Name] || ''}
                            onChange={(e) => {
                                const newValue = e.target.value === "" ? 0 : e.target.value
                                createStructureADR(newValue, value.Name, line.Id, 'Insurance')
                            }}
                            disabled={operation === 'view' ? true : false}
                        />
                    )
                } else if (value.Type === 'datetime') {
                    return (
                        <M_InputTextField
                            type="date"
                            value={line[value.Name] || ''}
                            onChange={(e) => createStructureADR(e.target.value, value.Name, line.Id, 'Insurance')}
                            disabled={operation === 'view' ? true : false}
                        />
                    )
                }
            }
        }
    }), [optionsInsurance, createStructureADR, t])

    const headerTableCapacity = useMemo(() => columnsCapacity.map((value, index) => {
        const dynamicCapacityIdField = "CapacityId" + value.valueId
        return {
            Id: index + 1,
            header: value.NormalizedName,
            field: value.Name,
            body: (line) => {
                if (value.Type === 'select') {
                    return (
                        <M_DrawerTableTextField
                            tableLabel={value.NormalizedName}
                            required={value.Required}
                            entity={value.ForeignTableName}

                            value={line[dynamicCapacityIdField] && {
                                [dynamicCapacityIdField]: line[dynamicCapacityIdField],
                                [value.ForeignKeyName]: line[value.Name]
                            } || null}

                            filterField={value.ForeignKeyName}
                            labelFields={[value.ForeignKeyName]}

                            onSubmitValue={obj => {
                                if (obj) {
                                    createStructureADR(obj[value.ForeignKeyName] || '', value.Name, line.Id, 'Capacity')
                                    createStructureADR(obj[value.ForeignTableToPassId] || 0, dynamicCapacityIdField, line.Id, 'Capacity')
                                } else {
                                    createStructureADR('', value.Name, line.Id, 'Capacity')
                                    createStructureADR('', dynamicCapacityIdField, line.Id, 'Capacity')
                                }
                            }}
                            disabled={operation === 'view' ? true : false}
                            valueField={dynamicCapacityIdField}
                        />
                    )
                } else if (value.Type === 'int32') {
                    return (
                        <M_InputTextField
                            style={{ width: '80px !important' }}
                            type="number"
                            value={line[value.Name] || ''}
                            onChange={(e) => createStructureADR(e.target.value, value.Name, line.Id, 'Capacity')}
                            disabled={operation === 'view' ? true : false}
                        />
                    )
                }
            },
            bodyStyle: { width: '400px', maxWidth: '100%' }
        }
    }), [columnsCapacity, createStructureADR, t])


    const addCapacityColumnGroup = () => {
        setCapacityColumnGroups(prev => prev + 1)
    }

    useEffect(() => {
        setDataCapacity(prev => prev.map(row => {
            const updatedRow = { ...row }
            for (let i = 1; i <= capacityColumnGroups; i++) {
                if (!(updatedRow[`Quantity${i}`])) updatedRow[`Quantity${i}`] = ''
                if (!(updatedRow[`Capacity${i}`])) updatedRow[`Capacity${i}`] = ''
                if (!(updatedRow[`CapacityId${i}`])) updatedRow[`CapacityId${i}`] = ''
            }
            return updatedRow
        }))
    }, [capacityColumnGroups])


    const addDangerClass = () => {
        setDataDangerClassDriver([...dataDangerClassDriver, { Id: dataDangerClassDriver?.length && dataDangerClassDriver[dataDangerClassDriver.length - 1]?.Id + 1 || 0 }])
    }

    const addLicenses = () => {
        setDataLicenses([...dataLicenses, { Id: dataLicenses?.length && dataLicenses[dataLicenses.length - 1]?.Id + 1 || 0 }])
    }

    const AddInsurance = () => {
        setDataInsurance([...dataInsurance, { Id: dataInsurance?.length && dataInsurance[dataInsurance.length - 1]?.Id + 1 || 0 }])
    }

    const addCapacity = () => {
        const lastId = dataCapacity.length > 0 ? dataCapacity[dataCapacity.length - 1]?.Id : -1
        const newId = lastId + 1

        const newRow = { Id: newId }

        for (let i = 1; i <= capacityColumnGroups; i++) {
            newRow[`Quantity${i}`] = ''
            newRow[`Capacity${i}`] = ''
            newRow[`CapacityId${i}`] = ''
        }

        setDataCapacity(prevDataCapacity => [...prevDataCapacity, newRow])
    }

    const deleteADR = useCallback((Id) => {
        setDataDangerClassDriver(prev => prev.filter(obj => obj.Id !== Id))
        ctx.toastMessages('success', '', t("DeleteLine"))
    }, [ctx, t])

    const deleteLicenses = useCallback((Id) => {
        setDataLicenses(prev => prev.filter(obj => obj.Id !== Id))
        ctx.toastMessages('success', '', t("DeleteLine"))
    }, [ctx, t])

    const deleteInsurance = useCallback((Id) => {
        setDataInsurance(prev => prev.filter(obj => obj.Id !== Id))
        ctx.toastMessages('success', '', t("DeleteLine"))
    }, [ctx, t])

    const deleteCapacity = useCallback((Id) => {
        setDataCapacity(prev => prev.filter(obj => obj.Id !== Id))
        ctx.toastMessages('success', '', t("DeleteLine"))
    }, [ctx, t])

    const handleNext = () => {
        if (activeStep < steps.length - 1) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1)
        }
    }

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1)
    }

    const getStepContent = (step) => {
        switch (step) {
            case 0:
                return (
                    <div className='divFormDriver'>
                        <div className='divDisplayFormDriver'>
                            {optionsTrailer.map((elem) => (
                                <div key={elem.Name}>
                                    {elem.Type === 'string' ? (
                                        elem.IsForeignKey ? (
                                            <Controller
                                                name={elem.ForeignTableToPassId}
                                                control={control}
                                                rules={{ required: elem.IsRequired ? t("RequiredField") : false }}
                                                render={({ field: { onChange, value } }) => (
                                                    <M_DrawerTableTextField
                                                        tableLabel={elem.NormalizedName}
                                                        label={elem.NormalizedName}
                                                        required={elem.Required}
                                                        entity={elem.ForeignTableName}
                                                        value={value ?
                                                            {
                                                                [elem.ForeignTableToPassId]: value,
                                                                [elem.ForeignKeyName]: foreignKeyNames[elem.Name] || dataTrailer.get(elem.Name)
                                                            } : null}
                                                        filterField={elem.ForeignKeyName}
                                                        labelFields={[elem.ForeignKeyName]}
                                                        onSubmitValue={obj => {
                                                            if (obj) {
                                                                onChange(obj[elem.ForeignTableToPassId])
                                                                setForeignKeyNames(prev => ({
                                                                    ...prev,
                                                                    [elem.Name]: obj[elem.ForeignKeyName]
                                                                }))
                                                            } else {
                                                                onChange(null)
                                                                setForeignKeyNames(prev => ({
                                                                    ...prev,
                                                                    [elem.Name]: null
                                                                }))
                                                            }
                                                        }}
                                                        disabled={operation === 'view' ? true : false}
                                                        valueField={elem.ForeignTableToPassId}
                                                        error={!!errors[elem.ForeignTableToPassId]}
                                                        helperText={errors[elem.ForeignTableToPassId] ? t("RequiredField") : ""}
                                                    />
                                                )}
                                            />
                                        ) : (
                                            <Controller
                                                name={elem.Name}
                                                control={control}
                                                rules={{ required: elem.IsRequired ? t("RequiredField") : false }}
                                                render={({ field }) => (
                                                    < M_InputTextField
                                                        {...field}
                                                        type={"text"}
                                                        label={elem.NormalizedName}
                                                        secondColor={"var(--color-red-dark)"}
                                                        required={elem.IsRequired}
                                                        error={!!errors[elem.Name]}
                                                        helperText={errors[elem.Name] ? t("RequiredField") : ""}
                                                        disabled={operation === 'view' || elem.disabled}
                                                    />
                                                )}
                                            />
                                        )
                                    ) : elem.Type === 'int32' || elem.Type === 'uint32' || elem.Type === 'decimal' ? (
                                        <Controller
                                            name={elem.Name}
                                            control={control}
                                            rules={{
                                                required: elem.IsRequired ? t("RequiredField") : false,
                                            }}
                                            render={({ field: { onChange, value, ...field } }) => (
                                                <M_InputTextField
                                                    {...field}
                                                    type={"text"}
                                                    label={elem.NormalizedName}
                                                    secondColor={"var(--color-red-dark)"}
                                                    required={elem.IsRequired}
                                                    onChange={(e) => {
                                                        let inputValue = e.target.value
                                                        if (/^[0-9,]*$/.test(inputValue) || inputValue === "") {
                                                            const cleanValue = inputValue.replace(",", ".")
                                                            onChange(cleanValue)
                                                        }
                                                    }}
                                                    value={value?.toString().replace(".", ",") || ""}
                                                    error={!!errors[elem.Name]}
                                                    helperText={errors[elem.Name] ? t("RequiredField") : ""}
                                                    disabled={operation === 'view' || elem.disabled}
                                                />
                                            )}
                                        />
                                    ) : elem.Type === 'datetime' ? (
                                        <Controller
                                            name={elem.Name}
                                            control={control}
                                            rules={{ required: elem.IsRequired ? t("RequiredField") : false }}
                                            render={({ field }) => (
                                                <M_InputTextField
                                                    {...field}
                                                    type={"date"}
                                                    label={elem.NormalizedName}
                                                    secondColor={"var(--color-red-dark)"}
                                                    required={elem.IsRequired}
                                                    error={!!errors[elem.Name]}
                                                    helperText={errors[elem.Name] ? t("RequiredField") : ""}
                                                    disabled={operation === 'view' || elem.disabled}
                                                />
                                            )}
                                        />
                                    ) : elem.Type === 'boolean' ? (
                                        <Controller
                                            name={elem.Name}
                                            control={control}
                                            render={({ field: { onChange, value, ...field } }) => (
                                                <M_CheckBox
                                                    {...field}
                                                    label={elem.NormalizedName}
                                                    onChange={(e) => onChange(e.target.checked)}
                                                    checked={!!value}
                                                    disabled={operation === 'view' || elem.disabled}
                                                />
                                            )}
                                        />
                                    ) : elem.Name === "SuspensionType" || elem.Name === 'GeneratorMountType' || elem.Name === 'SpecialGeneratorMountType' ||
                                        elem.Name === 'State' || elem.Name === 'AxleType' || elem.Name === 'TireType' || elem.Name === 'BrakeType' || elem.Name === 'SpecificEngine' ? (
                                        <Controller
                                            name={elem.Name}
                                            control={control}
                                            rules={{ required: elem.IsRequired ? t("RequiredField") : false }}
                                            defaultValue={elem.EnumValues?.[0]?.Value ?? ""}
                                            render={({ field }) => (
                                                <M_Select
                                                    {...field}
                                                    noNone
                                                    label={elem.NormalizedName}
                                                    options={elem.EnumValues?.map(elem => ({
                                                        label: elem.Label,
                                                        value: elem.Value
                                                    })) || []}
                                                    required={elem.IsRequired}
                                                    error={!!errors[elem.Name]}
                                                    helperText={errors[elem.Name] ? t("RequiredField") : ""}
                                                />
                                            )}
                                            disabled={operation === 'view' || elem.disabled}
                                        />
                                    ) : null}
                                </div>
                            ))}
                        </div>
                    </div>
                )
            case 1:
                return (
                    <>
                        <div className='divTableADRCapacity'>
                            {/* tabela do ADR */}
                            <div className='divTableADRandCapacity'>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div className='divLabelName'>
                                        <img src="/icons/svgsDaNet/radioactive.svg" alt="icon" className='iconTablesCreateTrailer' />
                                        {t("DangerClass")}</div>
                                    <div>
                                        <M_Button
                                            label={t("AddADR")}
                                            icon={<img src="/icons/svgsDaNet/add-circle.svg"
                                                style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)', width: '24px' }}
                                                alt="save" />
                                            }
                                            borderColor={'var(--color-grey)'}
                                            onClick={addDangerClass}
                                            disabled={operation === 'view' || false}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <M_SimpleTable
                                        columns={[
                                            ...headerTableADR,
                                            {
                                                body: (line) => {
                                                    return (
                                                        <div>
                                                            <img src="/icons/svgsDaNet/trash-2.svg"
                                                                style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                                                                alt="Delete" className='iconDeleteAddress' onClick={() => deleteADR(line.Id)}
                                                            />
                                                        </div>
                                                    )
                                                }
                                            }
                                        ]}
                                        rows={dataDangerClassDriver}
                                    />
                                </div>
                            </div>

                            {/* tabela da capacidade do trailer */}
                            <div className='divTableADRandCapacity'>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div className='divLabelName'>
                                        <img src="/icons/svgsDaNet/ruler-2.svg" alt="icon" className='iconTablesCreateTrailer' />
                                        {t("CapacityTrailer")}
                                    </div>
                                    <div style={{ display: 'flex', gap: '10px' }}>
                                        <M_Button
                                            label={t("AddCapacity")}
                                            icon={<img src="/icons/svgsDaNet/add-circle.svg"
                                                style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)', width: '24px' }}
                                                alt="save" />
                                            }
                                            borderColor={'var(--color-grey)'}
                                            onClick={addCapacity}
                                            disabled={operation === 'view' || false}
                                        />

                                        <M_Button
                                            label={t("AddConcCapacity")}
                                            icon={<img src="/icons/svgsDaNet/add-circle.svg"
                                                style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)', width: '24px' }}
                                                alt="save" />
                                            }
                                            borderColor={'var(--color-grey)'}
                                            onClick={addCapacityColumnGroup}
                                            disabled={operation === 'view' || false}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <M_SimpleTable
                                        columns={[
                                            ...headerTableCapacity,
                                            {
                                                body: (line) => {
                                                    return (
                                                        <div>
                                                            <img src="/icons/svgsDaNet/trash-2.svg"
                                                                style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                                                                alt="Delete" className='iconDeleteAddress' onClick={() => deleteCapacity(line.Id)}
                                                            />
                                                        </div>
                                                    )
                                                }
                                            }
                                        ]}
                                        rows={dataCapacity}
                                    />
                                </div>
                            </div>

                            {/* tabela das licenças */}
                            <div className='divTableADRandCapacity'>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div className='divLabelName'>
                                        <img src="/icons/svgsDaNet/license.svg" alt="icon" className='iconTablesCreateTrailer' />
                                        {t("Licenses")}</div>
                                    <div>
                                        <M_Button
                                            label={t("addLicense")}
                                            icon={<img src="/icons/svgsDaNet/add-circle.svg"
                                                style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)', width: '24px' }}
                                                alt="save" />
                                            }
                                            borderColor={'var(--color-grey)'}
                                            onClick={addLicenses}
                                            disabled={operation === 'view' || false}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <M_SimpleTable
                                        columns={[
                                            ...headerLicenses,
                                            {
                                                body: (line) => {
                                                    return (
                                                        <div>
                                                            <img src="/icons/svgsDaNet/trash-2.svg"
                                                                style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                                                                alt="Delete" className='iconDeleteAddress' onClick={() => deleteLicenses(line.Id)}
                                                            />
                                                        </div>
                                                    )
                                                }
                                            }
                                        ]}
                                        rows={dataLicenses}
                                    />
                                </div>
                            </div>
                        </div>


                        {/* tabela dos Seguros */}
                        <div className='divTableADRandCapacity'>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div className='divLabelName'>
                                    <img src="/icons/svgsDaNet/shield.svg" alt="icon" className='iconTablesCreateTrailer' />
                                    {t("Insurances")}</div>
                                <div>
                                    <M_Button
                                        label={t("AddInsurance")}
                                        icon={<img src="/icons/svgsDaNet/add-circle.svg"
                                            style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)', width: '24px' }}
                                            alt="save" />
                                        }
                                        borderColor={'var(--color-grey)'}
                                        onClick={AddInsurance}
                                        disabled={operation === 'view' || false}
                                    />
                                </div>
                            </div>
                            <div>
                                <M_SimpleTable
                                    columns={[
                                        ...headerTableInsurances,
                                        {
                                            body: (line) => {
                                                return (
                                                    <div>
                                                        <img src="/icons/svgsDaNet/trash-2.svg"
                                                            style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                                                            alt="Delete" className='iconDeleteAddress' onClick={() => deleteInsurance(line.Id)}
                                                        />
                                                    </div>
                                                )
                                            }
                                        }
                                    ]}
                                    rows={dataInsurance}
                                />
                            </div>
                        </div>
                    </>
                )
            default:
                return <div>Formulário Finalizado</div>
        }
    }

    return (
        <div className='divFormTable'>
            <div className="displayMenuActions">
                <div className="menuIcon">
                    <Tooltip title={t("Close")} className='iconsHeaderTable'>
                        <div className='iconsHeaderTable' onClick={() => ctx2.closeTab(id)}>
                            <i className="pi pi-arrow-left iconTable"></i>
                            <span className='labelCRUDTable'><b>{t("Close")}</b></span>
                        </div>
                    </Tooltip>
                    {operation !== 'view' &&
                        <Tooltip title={t("Save")}>
                            <div className='iconsHeaderTable' onClick={handleSubmit(onSubmit, onError)}>
                                <i className="pi pi-save iconTable"></i>
                                <span className='labelCRUDTable'><b>{t("Save")}</b></span>
                            </div>
                        </Tooltip>
                    }
                </div>
            </div>
            <div className='dividerMenu'></div>
            <div className='divPrincipalAlignFormDriver'>
                <div className='divPrincoipalTitleOrderServiceinTabs'>
                    <div className='titleTab'>
                        <img
                            src={activeStep === 0 ? "/icons/svgsDaNet/trailer.svg" :
                                activeStep === 1 ? "/icons/svgsDaNet/radioactive.svg" :
                                    "/icons/svgsDaNet/crane.svg"
                            }
                            alt='icon'
                            style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                        />
                        {t(steps[activeStep])}
                    </div>
                </div>
                <Stepper
                    alternativeLabel={matchesAlternative && !matches}
                    orientation={matches ? "vertical" : "horizontal"}
                    activeStep={activeStep}
                    sx={{
                        '& .MuiStep-root': {
                            '& .Mui-completed .MuiStepIcon-root': {
                                color: 'var(--color-red-dark)',
                            },
                            '& .Mui-completed .MuiStepConnector-line': {
                                borderColor: 'var(--color-red-dark)',
                            },
                            '& .MuiStepIcon-root.Mui-active': {
                                color: 'var(--color-red-light)'
                            }
                        },
                    }}
                >
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel><b>{t(label)}</b></StepLabel>
                        </Step>
                    ))}
                </Stepper>
                <div>
                    <div className='divButtonsBackNext'>
                        <div className='divButtonBack'>
                            <M_Button
                                disabled={activeStep === 0}
                                onClick={handleBack}
                                label={t("Back")}
                                icon={<i className="pi pi-arrow-left iconTable"></i>}
                                borderColor={'var(--color-grey)'}
                            />
                        </div>
                        <div className='divButtonNext'>
                            <M_Button
                                onClick={handleNext}
                                disabled={activeStep === steps.length - 1}
                                label={t("Next")}
                                icon={<i className="pi pi-arrow-right iconTable"></i>}
                                borderColor={'var(--color-grey)'}
                                iconPosition={'right'}
                            />
                        </div>
                    </div>
                    {getStepContent(activeStep)}
                </div>
            </div>
        </div>
    )
}